import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';

type EmailChipValue = { value: string; valid: boolean };

@Component({
  selector: 'email-chip-input',
  templateUrl: './email-chip-input.component.html',
  styleUrls: ['./email-chip-input.component.scss']
})
export class EmailChipInput {
  @Output() public input = new EventEmitter();

  public values: EmailChipValue[] = [];

  public get value(): string[] {
    return this.values.map(({ value }) => value);
  }

  public addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA, SPACE] as const;

  private validateEmail(email: string): boolean {
    return Validators.email(new FormControl(email.toLowerCase())) === null;
  }

  public getIconColor(email: { value: string; valid: boolean }): string {
    return email.valid ? 'var(--tar-grey)' : 'var(--red-velvet)';
  }

  public add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (!value) {
      return;
    }
    // Check value is valid
    const valid = this.validateEmail(value);
    const item = { value, valid };

    this.values.push(item);

    // Clear the input value
    event.chipInput?.clear();

    this.input.emit({ target: this });
  }

  public remove(email: string): void {
    const index = this.value.indexOf(email);

    if (index >= 0) {
      this.values.splice(index, 1);
    }

    this.input.emit({ target: this });
  }
}
